/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Rows a purge deleted, per kind of data.
 * @export
 * @interface OrganizationPurgeCounts
 */
export interface OrganizationPurgeCounts {
    /**
     * The organization's teams in events
     * @type {number}
     * @memberof OrganizationPurgeCounts
     */
    competitors: number;
    /**
     * Submissions of those teams
     * @type {number}
     * @memberof OrganizationPurgeCounts
     */
    submissions: number;
    /**
     * Event participations
     * @type {number}
     * @memberof OrganizationPurgeCounts
     */
    events: number;
    /**
     * 
     * @type {number}
     * @memberof OrganizationPurgeCounts
     */
    workshops: number;
    /**
     * 
     * @type {number}
     * @memberof OrganizationPurgeCounts
     */
    classes: number;
    /**
     * 
     * @type {number}
     * @memberof OrganizationPurgeCounts
     */
    tutorial_assignments: number;
    /**
     * Role rows in the organization
     * @type {number}
     * @memberof OrganizationPurgeCounts
     */
    memberships: number;
}

/**
 * Check if a given object implements the OrganizationPurgeCounts interface.
 */
export function instanceOfOrganizationPurgeCounts(value: object): value is OrganizationPurgeCounts {
    if (!('competitors' in value) || value['competitors'] === undefined) return false;
    if (!('submissions' in value) || value['submissions'] === undefined) return false;
    if (!('events' in value) || value['events'] === undefined) return false;
    if (!('workshops' in value) || value['workshops'] === undefined) return false;
    if (!('classes' in value) || value['classes'] === undefined) return false;
    if (!('tutorial_assignments' in value) || value['tutorial_assignments'] === undefined) return false;
    if (!('memberships' in value) || value['memberships'] === undefined) return false;
    return true;
}

export function OrganizationPurgeCountsFromJSON(json: any): OrganizationPurgeCounts {
    return OrganizationPurgeCountsFromJSONTyped(json, false);
}

export function OrganizationPurgeCountsFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationPurgeCounts {
    if (json == null) {
        return json;
    }
    return {
        
        'competitors': json['competitors'],
        'submissions': json['submissions'],
        'events': json['events'],
        'workshops': json['workshops'],
        'classes': json['classes'],
        'tutorial_assignments': json['tutorial_assignments'],
        'memberships': json['memberships'],
    };
}

export function OrganizationPurgeCountsToJSON(json: any): OrganizationPurgeCounts {
    return OrganizationPurgeCountsToJSONTyped(json, false);
}

export function OrganizationPurgeCountsToJSONTyped(value?: OrganizationPurgeCounts | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'competitors': value['competitors'],
        'submissions': value['submissions'],
        'events': value['events'],
        'workshops': value['workshops'],
        'classes': value['classes'],
        'tutorial_assignments': value['tutorial_assignments'],
        'memberships': value['memberships'],
    };
}

